import React from 'react';

interface EntryImageProp {
  label: string;
  value: any;
  visible?: boolean;
  preview?: boolean;
}
export default function EntryImage({
  label,
  value,
  visible = true,
  preview = true,
}: EntryImageProp) {
  return visible && (
    <div className="entry-field entry-image">
      <label>{label}</label>
      <div>
        {preview && (
          <img src={value} alt={label} />
        )}
        {!preview && (
          <p>添付あり</p>
        )}
      </div>
    </div>
  );
}